import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MediaCard from '@/components/base/MediaCard';
import { usePageMeta } from '@/hooks/usePageMeta';
import { useFavorites } from '@/hooks/useFavorites';
import { mediaList } from '@/mocks/movies';

export default function FavoritesPage() {
  const { t } = useTranslation();
  const { favorites } = useFavorites();

  usePageMeta(
    `${t('favoritesTitle')} - 久久精品影视资源`,
    '查看你在久久久精品收藏的影视作品，收藏内容保存在本机浏览器中。',
    '久久久精品,我的收藏,影视收藏',
  );

  const items = mediaList.filter((item) => favorites.includes(item.id));

  return (
    <div className="jjj-fade-up">
      <div className="bg-primary-950">
        <div className="mx-auto max-w-page px-4 py-10 md:px-6 md:py-14">
          <nav className="mb-4 flex items-center gap-2 text-xs text-background-200/70">
            <Link to="/" className="transition hover:text-accent-300 cursor-pointer">{t('breadcrumbHome')}</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-accent-400">{t('navFavorites')}</span>
          </nav>
          <h1 className="flex items-center gap-3 font-heading text-2xl font-extrabold text-background-50 md:text-3xl">
            <i className="ri-heart-3-line text-accent-400"></i>
            {t('favoritesTitle')}
          </h1>
          <p className="mt-3 text-sm text-background-100/80">{t('favoritesDesc')} · 共 {items.length} 部</p>
        </div>
      </div>

      <div className="mx-auto max-w-page px-4 py-8 md:px-6 md:py-10">
        {items.length === 0 ? (
          <div className="flex flex-col items-center rounded-lg border border-dashed border-background-300 bg-background-50 py-20 text-center">
            <i className="ri-heart-3-line text-5xl text-foreground-300"></i>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{t('favoritesEmpty')}</h3>
            <Link
              to="/"
              className="mt-6 flex items-center gap-1.5 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-compass-3-line"></i>
              {t('goExplore')}
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-5">
            {items.map((item) => (
              <MediaCard key={item.id} item={item} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}